<div
  class="lumi-chat-message lumi-chat-stagger-item"
  [ngClass]="'lumi-chat-message--' + message.type"
>
  <ng-container *ngIf="message.type === 'bot'">
    <div class="lumi-chat-avatar">
      <img [src]="message.avatarUrl" alt="Lumi">
    </div>
  </ng-container>

  <div
    class="lumi-chat-bubble"
    [ngClass]="'lumi-chat-bubble--' + message.type"
    [class.lumi-chat-bubble--pending]="isBotPending"
  >
    <ng-container *ngIf="isBotPending">
      <span class="lumi-typing-indicator" aria-label="Lumi is typing">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </ng-container>
    <span class="lumi-chat-bot-stream" *ngIf="!isBotPending">
      <span class="lumi-chat-bot-content" [innerHTML]="message.content"></span><span
        *ngIf="showInlineStreamTyping"
        class="lumi-typing-indicator lumi-typing-indicator--inline"
        aria-hidden="true"
      ><span></span><span></span><span></span></span>
    </span>
    <div
      *ngIf="message.sources?.length"
      class="lumi-chat-sources"
      [class.lumi-chat-sources--project]="message.sourceCitationStyle === 'project'"
    >
      <span
        class="lumi-chat-sources-label"
        [@fadeInUp]="{ value: '', params: { delay: 0 } }"
      >{{message.sourcesLabel || 'Found in:'}}</span>
      <a
        *ngFor="let source of message.sources; let i = index"
        class="lumi-chat-source-link"
        [@fadeInUp]="{ value: '', params: { delay: sourceCitationRowDelay(i) } }"
        [attr.href]="sourceLinkHref(source)"
        [attr.target]="sourceLinkTarget(source)"
        [attr.rel]="sourceLinkRel(source)"
        (click)="onSourceLinkClick($event, source)"
      >
        <span>{{source.label}}</span>
        <app-centrui-icon
          class="lumi-chat-source-chevron"
          [file]="'ic-chevron-right.svg'"
          [svgStyle]="{'stroke': 'transparent', 'fill': '#ffffff'}"
        ></app-centrui-icon>
      </a>
    </div>
    <ng-container *ngFor="let section of message.panelRefSections; let sectionIndex = index">
      <div
        *ngIf="section.refs?.length"
        class="lumi-chat-sources lumi-chat-sources--project"
      >
        <span
          class="lumi-chat-sources-label"
          [@fadeInUp]="{ value: '', params: { delay: 0 } }"
        >{{section.label}}</span>
        <a
          *ngFor="let ref of section.refs; let refIndex = index"
          class="lumi-chat-source-link"
          [@fadeInUp]="{ value: '', params: { delay: panelRefRowDelay(sectionIndex, refIndex) } }"
          href="#"
          (click)="onPanelRefClick($event, ref)"
        >
          <span>{{ref.label}}</span>
          <app-centrui-icon
            class="lumi-chat-source-chevron"
            [file]="'ic-chevron-right.svg'"
            [svgStyle]="{'stroke': 'transparent', 'fill': '#ffffff'}"
          ></app-centrui-icon>
        </a>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="message.type === 'bot' && message.showFeedback">
    <div class="lumi-chat-message-footer">
      <div class="lumi-chat-feedback">
        <button
          class="lumi-chat-feedback-btn"
          [class.lumi-chat-feedback-btn--active-up]="feedbackGiven === 'up'"
          pxTooltip="Useful"
          aria-label="Useful"
          (click)="giveFeedback('up')"
        >
          <app-centrui-icon [file]="'ic-upvote.svg'" [svgStyle]="{'stroke': '#9CA3AF', 'fill': 'transparent'}"></app-centrui-icon>
        </button>
        <button
          class="lumi-chat-feedback-btn lumi-chat-feedback-btn--down"
          [class.lumi-chat-feedback-btn--active-down]="feedbackGiven === 'down'"
          pxTooltip="Could be better"
          aria-label="Could be better"
          (click)="giveFeedback('down')"
        >
          <app-centrui-icon [file]="'ic-upvote.svg'" [svgStyle]="{'stroke': '#9CA3AF', 'fill': 'transparent'}"></app-centrui-icon>
        </button>
      </div>
      <div *ngIf="message.timestamp" class="lumi-chat-timestamp">{{message.timestamp}}</div>
    </div>
    <div
      class="lumi-chat-feedback-hint-wrapper"
      *ngIf="!showThankYou && !feedbackGiven"
      [@fadeInDelayed]="{ value: '', params: { delay: feedbackHintFadeDelayMs() } }"
    >
      <img class="lumi-chat-feedback-arrow" src="assets/img/polarix-onBoardingArrow-TopLeft.svg" alt="">
      <span class="lumi-chat-feedback-hint">Give your response a thumbs up if it was useful, and a thumbs down if it could be better!</span>
    </div>
    <div class="lumi-chat-feedback-thankyou" [class.fading-out]="thankYouFadingOut" *ngIf="showThankYou">
      <button class="lumi-chat-feedback-thankyou-dismiss" (click)="dismissThankYou.emit()">
        <app-centrui-icon [file]="'ic-close.svg'" [svgStyle]="{'fill': '#AAAAAA'}"></app-centrui-icon>
      </button>
      <div class="lumi-chat-feedback-thankyou-emoji">🙏</div>
      <p class="lumi-chat-feedback-thankyou-message">Thank you — your feedback helps us make Lumi even better.*</p>
      <p class="lumi-chat-feedback-thankyou-note">* All feedback is completely confidential and handled anonymously to protect your privacy.</p>
    </div>
  </ng-container>

  <ng-container *ngIf="message.type === 'user'">
    <div class="lumi-chat-avatar">
      <img [src]="message.avatarUrl" [alt]="'User'">
    </div>
  </ng-container>

  <ng-container *ngIf="message.type === 'bot' && !message.showFeedback && message.timestamp">
    <div class="lumi-chat-message-footer lumi-chat-message-footer--timestamp-only">
      <div class="lumi-chat-timestamp">{{message.timestamp}}</div>
    </div>
  </ng-container>
</div>
